import { User } from './store';

export const CREATE_USER = 'auth/system/created_user';
export const UPDATE_USER_PREMIUM_STATUS = 'auth/system/updated_premium';
export const UPDATE_USER_ADDITIONAL_DETAILS = 'auth/system/updated_additional_details';
export const LOGOUT_USER = 'auth/user/logout_user';
export const LOADING = 'auth/system/loading';

export interface CreateUserAction {
  type: typeof CREATE_USER;
  payload: User;
}

export interface UpdateUserPremiumStatus {
  type: typeof UPDATE_USER_PREMIUM_STATUS;
  payload: boolean;
}

export interface LogoutUserAction {
  type: typeof LOGOUT_USER;
  payload: null;
}

export interface UpdateUserAdditionalDetailsAction {
  type: typeof UPDATE_USER_ADDITIONAL_DETAILS;
  payload: User;
}

export interface LoadingAction {
  type: typeof LOADING;
  payload: boolean;
}

export type AuthenticationActionTypes =
  | CreateUserAction
  | UpdateUserPremiumStatus
  | LogoutUserAction
  | UpdateUserAdditionalDetailsAction
  | LoadingAction;
